export default __webpack_public_path__ + "static/media/antartica.236f9e96.png";